module.exports = __webpack_public_path__ + "img/check.191c595a.svg";